import { render, staticRenderFns } from "./RoomWaiting.vue?vue&type=template&id=622c1644&scoped=true&"
import script from "./RoomWaiting.vue?vue&type=script&lang=js&"
export * from "./RoomWaiting.vue?vue&type=script&lang=js&"
import style0 from "./RoomWaiting.vue?vue&type=style&index=0&id=622c1644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c1644",
  null
  
)

export default component.exports